<div style="text-align: center;">
        <!-- <h1 class="jeopardy-logo on neon">JEOPARDY!</h1> -->
        <h1 class="jeopardy-logo on neon">CHALLENG<span class="logo-eu logo-bigger">EU</span>!</h1>
</div>

